import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "finance-dashboard stock-dashboard" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = { class: "column is-12 box has-background-grey-darker" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title mb-5" }, "Dashboard")
], -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "asset-category mb-5 box has-background-grey-dark" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title is-4" }, "My Orders")
], -1)
const _hoisted_8 = { class: "category" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-tablet-alt"
    })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Orders", -1)
const _hoisted_11 = { class: "asset-category mb-5 box has-background-grey-dark" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title is-4" }, "Builder Tools")
], -1)
const _hoisted_13 = { class: "category" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-strategy"
    })
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Strategies", -1)
const _hoisted_16 = { class: "category" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-slideshow"
    })
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Page Builder", -1)
const _hoisted_19 = { class: "asset-category mb-5 box has-background-grey-dark" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title is-4" }, "Live Quotes")
], -1)
const _hoisted_21 = { class: "category" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-thumbnail"
    })
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Custom Page", -1)
const _hoisted_24 = { class: "category" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-notification"
    })
  ])
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Alert spreads", -1)
const _hoisted_27 = { class: "category" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-scaling"
    })
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Yield spreads", -1)
const _hoisted_30 = { class: "category" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-house-plan"
    })
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "House indices", -1)
const _hoisted_33 = {
  key: 0,
  class: "asset-category mb-5 box has-background-grey-dark"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title is-4" }, "Staff Area")
], -1)
const _hoisted_35 = { class: "category" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-analytics-alt-1"
    })
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Drift", -1)
const _hoisted_38 = { class: "category" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-target-alt-1"
    })
  ])
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Yield check", -1)
const _hoisted_41 = { class: "category" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-tablet-alt"
    })
  ])
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Orders list", -1)
const _hoisted_44 = { class: "category" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-sales-report"
    })
  ])
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "EOD repo", -1)
const _hoisted_47 = { class: "category" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-layers"
    })
  ])
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Repo history", -1)
const _hoisted_50 = { class: "category" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "asset" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asset-logo" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnil lnil-mask"
    })
  ])
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "asset-name" }, "Groups", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_RouterLink, { to: { name: 'customer-orders-list' } }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_RouterLink, { to: { name: 'strats-list' } }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_RouterLink, { to: { name: 'custom-page-builder' } }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_RouterLink, { to: { name: 'stream-custom' } }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_RouterLink, { to: { name: 'stream-alerts' } }, {
                default: _withCtx(() => [
                  _hoisted_25,
                  _hoisted_26
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_RouterLink, { to: { name: 'yield' } }, {
                default: _withCtx(() => [
                  _hoisted_28,
                  _hoisted_29
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_RouterLink, { to: { name: 'stream-futures' } }, {
                default: _withCtx(() => [
                  _hoisted_31,
                  _hoisted_32
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.isStaff)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_RouterLink, { to: { name: 'drift' } }, {
                    default: _withCtx(() => [
                      _hoisted_36,
                      _hoisted_37
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_RouterLink, { to: { name: 'yield-check' } }, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _hoisted_40
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_RouterLink, { to: { name: 'orders-list' } }, {
                    default: _withCtx(() => [
                      _hoisted_42,
                      _hoisted_43
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_RouterLink, { to: { name: 'endofdayrepo' } }, {
                    default: _withCtx(() => [
                      _hoisted_45,
                      _hoisted_46
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_RouterLink, { to: { name: 'repo-history' } }, {
                    default: _withCtx(() => [
                      _hoisted_48,
                      _hoisted_49
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_RouterLink, { to: { name: 'group-page-builder-users' } }, {
                    default: _withCtx(() => [
                      _hoisted_51,
                      _hoisted_52
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}